import { render, staticRenderFns } from "./ObjectMenu.vue?vue&type=template&id=5103180a&scoped=true&"
import script from "./ObjectMenu.vue?vue&type=script&lang=ts&"
export * from "./ObjectMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103180a",
  null
  
)

export default component.exports